import React from 'react';
import HeroSection from './HeroSection';
import InterviewsSection from './InterviewsSection';
import JoinTheClub from '../HomePage/JoinTheClub';

const InterviewsPage: React.FC = () => {
  return (
    <>
      <HeroSection />
      <InterviewsSection />
      <JoinTheClub />
    </>
  );
};

export default InterviewsPage;
